import { jsx } from 'react/jsx-runtime';
import { CloseIcon } from '@flex-design-system/legacy-flex-icons';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PrimitiveButton } from '../../../button/primitive-button/PrimitiveButton.mjs';
import { closeIconButton } from './closeIconButton.vanilla.mjs';

const ModalCloseIconButton = forwardRef(
  ({ icon, className: classNameFromProps, clickableStyle = "none", ...props }, ref) => {
    return /* @__PURE__ */ jsx(DialogPrimitive.Close, { asChild: true, children: /* @__PURE__ */ jsx(
      PrimitiveButton,
      {
        className: classNames(closeIconButton, classNameFromProps),
        clickableStyle,
        ref,
        ...props,
        children: icon ? icon : /* @__PURE__ */ jsx(CloseIcon, { size: 26, color: "black012" })
      }
    ) });
  }
);

export { ModalCloseIconButton };
//# sourceMappingURL=CloseIconButton.mjs.map
